module.exports = __webpack_public_path__ + "static/media/img_3-20.59adf84a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/img_3-20.svg
// module id = 681
// module chunks = 0